/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import Icon from '@mui/icons-material/Edit';
import { useTheme } from 'styled-components';
import { IconButton, styleIcon } from './IconButton';
import { IconButtonProps } from './types';
import { joinDataTestId } from '@motili/ui';

const StyledIcon = styleIcon(Icon);

export const EditIconButton = ({
    disabled,
    iconColor,
    controlId,
    ...rest
}: IconButtonProps) => {
    const theme = useTheme();
    const _controlId = joinDataTestId([controlId, 'edit-icon']);
    return (
        <IconButton disabled={disabled} {...rest} controlId={_controlId}>
            <StyledIcon
                data-test-id='EditIcon'
                disabled={disabled}
                iconColor={iconColor || theme.color('primary')}
            />
        </IconButton>
    );
};
